
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

export type OptionTab = {
  label: string;
  value: string;
  icon: string;
  description: string;
  action?: () => void;
};

@Component({
  components: {
    Icon
  }
})
export default class SingularityOption extends Vue {
  @Prop()
  title!: string;
  @Prop()
  description!: string;
  @Prop({ default: "SparklesIcon" }) icon!: string;
}
